// extracted by mini-css-extract-plugin
export var integrationButton = "_98-0";